"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'YsProvider',
  render: function () {
    if (this.$scopedSlots.default) {
      return this.$scopedSlots.default();
    }
    return undefined;
  },
  props: {
    searchForm: {
      type: Object,
      default: () => ({})
    },
    api: {
      type: Object,
      default: () => ({})
    }
  },
  provide() {
    return {
      ysProviderContext: this.$props
    };
  }
};